"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Accordion = _interopRequireDefault(require("../Accordion"));
var _OutputFactory = _interopRequireDefault(require("../OutputFactory"));
var _CollapseView = _interopRequireDefault(require("./CollapseView"));
var _AccordionProvider = _interopRequireDefault(require("../Accordion/AccordionProvider"));
var _AccordionCollapse = _interopRequireDefault(require("../Accordion/AccordionCollapse"));
var _htmlId = _interopRequireDefault(require("../htmlId"));
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/Table/Body.js";
var timeoutId;
function Body(_ref) {
  var _this = this;
  var objects = _ref.objects,
    fields = _ref.fields,
    columns = _ref.columns,
    excludes = _ref.excludes,
    selected = _ref.selected,
    selectable = _ref.selectable,
    onSelect = _ref.onSelect,
    onClick = _ref.onClick,
    onLongPress = _ref.onLongPress,
    actionsList = _ref.actionsList,
    collapsable = _ref.collapsable,
    onCollapse = _ref.onCollapse,
    toggleable = _ref.toggleable,
    actions = _ref.actions,
    onClickItem = _ref.onClickItem,
    fieldImage = _ref.fieldImage;
  var onPointerDown = function onPointerDown() {
    timeoutId = setTimeout(onLongPress, 500); // set long press time to 500ms
  };
  var onPointerUp = function onPointerUp() {
    clearTimeout(timeoutId);
  };
  return objects.map(function (object, index) {
    var id = (0, _htmlId["default"])(object.id || object._id || index);
    var checked = selected.includes(object);
    return /*#__PURE__*/_react["default"].createElement(_AccordionProvider["default"], {
      key: id,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react["default"].createElement("tr", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 13
      }
    }, selectable && /*#__PURE__*/_react["default"].createElement("th", {
      className: "align-middle",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 33
      }
    }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      checked: checked,
      id: 'check_' + id,
      onChange: function onChange() {
        return onSelect(index);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44,
        columnNumber: 21
      }
    })), columns.map(function (field, i) {
      var options = fields[field];
      if (excludes.includes(field)) return null;
      return /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
        as: "td",
        eventKey: "_".concat(id),
        key: field,
        className: "fs-sm text-truncate",
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
        // onClick={() => onClick(index, field)}
        ,
        style: {
          cursor: 'pointer',
          maxWidth: '15em'
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 29
        }
      }, /*#__PURE__*/_react["default"].createElement(_OutputFactory["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 25
        }
      })));
    }), actionsList.length > 0 && /*#__PURE__*/_react["default"].createElement("td", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 45
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: "50px"
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 21
      }
    })), actionsList.map(function (action) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: "text-truncate",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76,
          columnNumber: 29
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        onClick: action.onClick && action.onClick.bind(_this, index),
        className: "btn btn-outline-primary btn-sm fs-xs shadow-none",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78,
          columnNumber: 25
        }
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: action.icon,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 29
        }
      }), " ", action.label));
    })), collapsable && /*#__PURE__*/_react["default"].createElement("tr", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 30
      }
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: "p-0",
      colSpan: columns.length + 1,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 87,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react["default"].createElement(_AccordionCollapse["default"], {
      toggleable: toggleable,
      className: "collapse p-3 ",
      eventKey: "_".concat(id),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 21
      }
    }, onCollapse(index, object, excludes) || (0, _CollapseView["default"])(index, object, excludes, fields, actions, onClickItem, fieldImage)))));
  });
}
var _default = exports["default"] = Body;